import React from 'react';
import { useTranslation } from '../i18n/LanguageContext.jsx';

// Regional-indicator emoji (🇵🇭 / 🇺🇸) fall back to bare letters on Windows,
// which is why the toggle read as plain "PH FIL" there. Draw the flags instead.
function FlagPh() {
  return (
    <svg viewBox="0 0 20 14" className="lang-toggle__flag" aria-hidden="true" focusable="false">
      <rect width="20" height="7" fill="#0038a8" />
      <rect y="7" width="20" height="7" fill="#ce1126" />
      <path d="M0 0 L8 7 L0 14 Z" fill="#fff" />
      <circle cx="2.6" cy="7" r="1.7" fill="#fcd116" />
    </svg>
  );
}

function FlagUs() {
  return (
    <svg viewBox="0 0 20 14" className="lang-toggle__flag" aria-hidden="true" focusable="false">
      <rect width="20" height="14" fill="#fff" />
      {[0, 2, 4, 6, 8, 10, 12].map((y) => (
        <rect key={y} y={y} width="20" height="1" fill="#b22234" />
      ))}
      <rect width="9" height="7" fill="#3c3b6e" />
    </svg>
  );
}

export default function LanguageToggle({ variant = 'dark' }) {
  const { lang, changeLang } = useTranslation();
  const isFil = lang === 'fil';

  const toggle = () => changeLang(isFil ? 'en' : 'fil');

  const btnClass = variant === 'light'
    ? 'btn btn-link text-white text-decoration-none p-0 border-0 lang-toggle lang-toggle--light'
    : 'btn btn-link text-decoration-none p-0 border-0 lang-toggle';

  return (
    <button
      type="button"
      className={btnClass}
      onClick={toggle}
      aria-label={isFil ? 'Switch to English' : 'Lumipat sa Filipino'}
      title={isFil ? 'Switch to English' : 'Lumipat sa Filipino'}
    >
      {isFil ? <FlagUs /> : <FlagPh />}
      <span className="lang-toggle__label">
        {isFil ? 'EN' : 'FIL'}
      </span>
    </button>
  );
}
